import type { RouterConfig } from '@nuxt/schema';
import { getLenis } from '~/utils/lenis';

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    const lenis = getLenis();

    // Hash navigation is handled by the scroll-offset plugin (which is Lenis-aware).
    if (to.hash) {
      return false;
    }

    const top = savedPosition ? savedPosition.top : 0;

    // When Lenis owns the scroll, reset through it — a native scrollTo would be
    // immediately overridden by Lenis's RAF loop (the "doesn't scroll to top" bug).
    // `immediate` for fresh navigations; animate restores for back/forward.
    if (lenis) {
      lenis.scrollTo(top, { immediate: true, force: true });
      return false;
    }

    return { top, left: 0, behavior: savedPosition ? 'auto' : 'smooth' };
  },
};
